module.exports = __webpack_public_path__ + "static/img/Andrew.Demetriou.a643166.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Andrew.Demetriou.jpg
// module id = FD09
// module chunks = 0